<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item>
        <a-input placeholder="请输入用户" allowClear v-model="filter.name" @change="init_data">
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-tree-select
          v-model="filter.group"
          style="width: 200px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto'}"
          :tree-data="groupList"
          allow-clear
          placeholder="请输入用户组"
          treeNodeFilterProp ="real_name"
          show-search
          tree-default-expand-all
          :replaceFields="{children:'children', title:'real_name', key:'id',value:'name' }"
          @change="init_data"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button icon="plus" @click="doAdd()"></a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.id"
             bordered :pagination="false">
      <template slot="auth" slot-scope="text,recode">
        {{text.length}}项
      </template>
      <template slot="handle" slot-scope="text,recode">
        <a-button size="small" @click="doAdd(recode)">编辑</a-button>
        <a-button size="small" type="danger" @click="doDelete(recode.id)">删除</a-button>
      </template>
      <template slot="footer" >
        <a-pagination
          v-model="filter.page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="filter.page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template>
    </a-table>
    <a-modal
      title="指标权限分配"
      :visible="addVisible"
      @ok="doSave()"
      @cancel="()=>{addVisible=false}"
    >
      <a-form-model :model="addInfo"
                    v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
        <a-form-model-item label="用户组" prop="name">
          <a-tree-select
            v-model="addInfo.group"
            style="width: 275px"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto'}"
            :tree-data="groupList"
            allow-clear
            placeholder="请输入用户组"
            treeNodeFilterProp ="real_name"
            show-search
            tree-default-expand-all
            :replaceFields="{children:'children', title:'real_name', key:'id',value:'name' }"
            @change="getUserList"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="用户" prop="desc">
          <a-select v-model="addInfo.user" allowClear show-search
                    optionFilterProp="label" :disabled="!addInfo.group"
                    placeholder="请选择接收消息的用户">
            <a-select-option v-for="userItem in userList"
                             :label="userItem.name"
                             :value="userItem.id"
                             :key="userItem.id">
              {{ userItem.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div style="max-height: 50vh;background: #EEEEEE;padding: 0 5px;border-radius: 5px;overflow-y: scroll;user-select: none">
        <div class="norm-panel"
             v-if="categoryIndex!=='compose'"
             v-for="(categoryItem,categoryIndex) in $store.state.report.dataCategory">
          <div class="norm-panel-label text-no" >
            <div style="cursor: pointer"
                 @click="choiceNormAll(categoryIndex)">
              {{categoryItem}}
            </div>
          </div>
          <div style="flex: 1" >
            <div class="norm-panel-item"
                 :class="addInfo.auth.includes(dataFieldItem.code)?'active':''"
                 @click="choiceNorm(dataFieldItem.code)"
                 v-for="dataFieldItem in dataFieldList[categoryIndex]">
              {{dataFieldItem.name}}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {GetGroupTree} from "../../api/v1/group_api";
import {AddNormAuth, DeleteNormAuth, GetNormAuthPage, GetNormList} from "../../api/v1/analysis";
import {GetUserAll} from "../../api/v1/user_api";

export default {
  name: "DictionariesAuth",
  data(){
    return {
      filter:{
        name:undefined,
        group:undefined,
        page:0,
        page_size:10,
      },
      tableData:[],
      tableLoad:false,
      count:0,
      groupList:[],
      userList:[],
      addVisible:false,
      addInfo:{
        user:undefined,
        group:undefined,
        auth:[],
      },
      dataFieldList:{},
    }
  },
  computed:{
    getTableColumns(){
      return [
        {title: '用户组', dataIndex: 'group_name',},
        {title: '用户', dataIndex: 'user_name'},
        {title: '权限', dataIndex: 'auth', scopedSlots: { customRender: 'auth' }},
        {title: '操作', dataIndex: 'handle',scopedSlots: { customRender: 'handle' }},
      ]
    }
  },
  mounted() {
    this.init_data()
    this.getNormList()
    this.getUserList()
    this.getGroupList()
  },
  methods: {
    getNormList(){
      GetNormList({type:'data',is_auth:false}).then(resp=>{
        this.dataFieldList = {}
        resp.data.forEach(item=>{
          if (!this.dataFieldList[item.category])this.dataFieldList[item.category] = []
          this.dataFieldList[item.category].push(item)
        })
      })
    },
    getUserList(){
      GetUserAll({group:this.addInfo.group}).then(resp =>{
        if (resp.code===200){
          this.userList = resp.data
        }
      })
    },
    getGroupList(){
      GetGroupTree({}).then(resp => {
        if (resp.code===200){
          this.groupList = resp.data
        }
      })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    init_data(){
      this.tableLoad = true
      GetNormAuthPage(this.filter).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.count = resp.data.count
          this.filter.page = resp.data.page
          this.filter.page_size = resp.data.page_size
          this.tableData = resp.data.list
        }
      })
    },
    choiceNormAll(index){
      this.dataFieldList[index].forEach(item=>{
        this.choiceNorm(item.code)
      })
    },
    choiceNorm(code){
      let _index = this.addInfo.auth.indexOf(code)
      if (_index===-1){
        this.addInfo.auth.push(code)
      }else{
        this.addInfo.auth.splice(_index,1)
      }
    },
    doAdd(info={group:'',user_id:'',auth:[]}){
      this.addInfo = {
        group:info.group,
        user:info.user_id,
        auth:info.auth
      }
      if (this.addInfo.group) this.getUserList()
      this.addVisible = true
    },
    doSave(){
      if (!this.addInfo){
        this.$message.error("用户组必须")
        return
      }
      AddNormAuth(this.addInfo).then(resp=>{
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.addVisible = false
          this.init_data()
        }
      })
    },
    doDelete(id){
      DeleteNormAuth({id:id}).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.init_data()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Report/DictionariesAuth.vue